import { ModelBase } from "../abstract/model-base.model";
import { AnalyticalAxis } from "./analytical-axis.model";

/** Équilibre d'un axe déclenché sur un porteur (entrée `axes` de l'état de ventilation). */
export class AnalyticalAxisState extends ModelBase {

    static override CLASS_NAME: string = 'AnalyticalAxisState';

    private _axis!: AnalyticalAxis;
    private _complete!: boolean;
    private _mandatory!: boolean;
    private _totalPercentage!: number;

    public get axis(): AnalyticalAxis {
        return this._axis;
    }

    public set axis(value: any) {
        this._setValue('_axis', value, 'AnalyticalAxis');
    }

    public get complete(): boolean {
        return this._complete;
    }

    public set complete(value: any) {
        this._setValue('_complete', value, 'boolean');
    }

    public get mandatory(): boolean {
        return this._mandatory;
    }

    public set mandatory(value: any) {
        this._setValue('_mandatory', value, 'boolean');
    }

    public get totalPercentage(): number {
        return this._totalPercentage;
    }

    public set totalPercentage(value: any) {
        this._setValue('_totalPercentage', value, 'float', { precision: 5 });
    }
}
